/**
 * @Author: v_jppjpeng
 * @Date: 2024-01-05 10:55:51
 * @Explain: 变量
 */
// 格式化日期输出正常顺序 =》 年月日时分秒
export const defaultDateFormat = 'YYYY-MM-DD HH:mm:ss';

// 格式化字符串，包含时区偏移量+00:00
export const defaultDateTimeZoneFormat = 'YYYY-MM-DDTHH:mm:ssZ';

// 格式化字符串，年月日
export const defaultDateFormatYMD = 'YYYY-MM-DD';

// 时间范围描述映射表
export const CHINESE_TIME_RANGES = {
  AM: {
    EARLY_MORNING: '凌晨', // 0-5点 (包括12am)
    MORNING: '上午', // 6-11点
  },
  PM: {
    NOON: '中午', // 12点
    AFTERNOON: '下午', // 1-5点
    EVENING: '晚上', // 6-11点
  },
} as const;
